import { useCallback, useState } from "react";

import type { BillingStatus } from "@/lib/gql/__generated__/graphql";

type UseCurrentTicketStateProps = {
	billingStatus: BillingStatus;
};

type UseCurrentTicketStateReturn = {
	isStopRecurringProBilling: boolean;
	onUpdateIsStopRecurringProBilling: () => void;
	onResetIsStopRecurringProBilling: () => void;
};

export const useCurrentTicketState = ({ billingStatus }: UseCurrentTicketStateProps): UseCurrentTicketStateReturn => {
	const [isStopRecurringProBilling, setIsStopRecurringProBilling] = useState(billingStatus.isStopRecurringProBilling);

	const onUpdateIsStopRecurringProBilling = useCallback(() => {
		setIsStopRecurringProBilling((prev) => !prev);
	}, []);

	const onResetIsStopRecurringProBilling = useCallback(() => {
		setIsStopRecurringProBilling(billingStatus.isStopRecurringProBilling);
	}, [billingStatus.isStopRecurringProBilling]);

	return {
		isStopRecurringProBilling,
		onUpdateIsStopRecurringProBilling,
		onResetIsStopRecurringProBilling,
	};
};
